<template>
  <div class="download-wrapper">
    <div class="download">
      <div
        class="close"
        @click="close"
      />
      <div class="logo">
        <img
          src="https://isee.weishi.qq.com/daguo/img/ws-ad2.png"
          alt="微视logo"
        >
      </div>
      <div class="content">
        <div class="title">
          好友们在等你
        </div>
        <div class="sub-title">
          去微视 APP 观看，高清更流畅
        </div>
      </div>
      <div
        class="open"
        @click="download"
      >
        {{ shouldShowDownloadText ? '下载微视' : '打开看看' }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

const enum EEmitEvent {
  onClose = 'on-close',
  onDownload = 'on-download',
}

export default defineComponent({
  props: {
    shouldShowDownloadText: {
      type: Boolean,
      default: false,
    },
  },
  emits: [EEmitEvent.onClose, EEmitEvent.onDownload],
  methods: {
    close() {
      this.$emit(EEmitEvent.onClose);
    },
    download() {
      this.$emit(EEmitEvent.onDownload);
    },
  },
});
</script>

<style lang="scss" scoped>
.download-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.7);
  .download {
    position: relative;
    @include responsiveStyleSingle(width, 68, 'vw');
    background: rgba(255, 255, 255, 0.95);
    @include responsiveStyleSingle(border-radius, 1.6, 'vw');
    .close {
      position: absolute;
      @include responsiveStyleSingle(right, 2.6667, 'vw');
      @include responsiveStyleSingle(top, 2.6667, 'vw');
      @include responsiveStyleSingle(width, 3.2, 'vw');
      @include responsiveStyleSingle(height, 3.2, 'vw');
      background-image: url('https://qzonestyle.gtimg.cn/qz-proj/weishi-mobile/sprite/page-share-play-190514164234@2x.png');
      @include responsiveStyleDouble(background-position, -512, -382, 'px');
      @include responsiveStyleDouble(background-size, 850, 724, 'px');
    }
    .logo {
      img {
        display: block;
        @include responsiveStyleSingle(width, 17.6, 'vw');
        @include responsiveStyleSingle(height, 17.6, 'vw');
        @include responsiveStyleSingle(margin-top, 10.1333, 'vw');
        @include responsiveStyleSingle(margin-bottom, 6.9333, 'vw');
        margin-left: auto;
        margin-right: auto;
      }
    }
    .content {
      text-align: center;
      .title {
        @include responsiveStyleSingle(font-size, 4.2667, 'vw');
        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
      }
      .sub-title {
        @include responsiveStyleSingle(font-size, 3.7333, 'vw');
        color: rgba(25, 27, 42, 0.7);
      }
    }
    .open {
      display: flex;
      align-items: center;
      justify-content: center;
      @include responsiveStyleSingle(width, 60, 'vw');
      @include responsiveStyleSingle(height, 10.6667, 'vw');
      @include responsiveStyleSingle(margin-top, 5.6,'vw');
      @include responsiveStyleSingle(margin-bottom, 5.6,'vw');
      @include responsiveStyleSingle(font-size, 3.7333, 'vw');
      margin-left: auto;
      margin-right: auto;
      font-weight: bold;
      background: #7a46ff;
      @include responsiveStyleSingle(border-radius, 5.3333, 'vw');
    }
  }
}
</style>
